// extracted by mini-css-extract-plugin
export default {"main":"DetailsRewardPage_main__bOIs2","container":"DetailsRewardPage_container__zMnyX","col":"DetailsRewardPage_col__yEpcw","recap":"DetailsRewardPage_recap__i5GQy"};